import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const ContentDiv = styled.div`
  max-height: 60vh;
  padding: 0 2.375rem;
  overflow-y: auto;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OuterWrapper = styled.div`
  padding: 1.375rem;
`;

export const ContainerLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;
export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 10px;
`;

export const MarginDiv = styled.div`
  ${(props) => props.marginInfo};
`;

export const CheckboxGridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
  max-width: 200px;
`;

export const ComponentContainer = styled.div`
  height: 300px;
  border: 1px solid;
  border-color: ${(props) => (props.error ? "red" : "#1BACE4")};
  padding: 10px;
  overflow: auto;
`;

export const ErrorLabel = styled.span`
  font-weight: bold;
  color: red;
  font-style: italic;
  float: left;
`;

export const ComponentContainerEmpty = styled.div`
  height: 300px;
  border: 1px solid;
  border-color: ${(props) => (props.error ? "red" : "#1BACE4")};
  text-align: center;
  line-height: 300px;
`;
